export const GET_BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE/get_user-_management';
export const GET_IMAGE = 'BIRTH_CERTIFICATE/GET_IMAGE';
export const UPLOAD_NEW_IMAGE = 'BIRTH_CERTIFICATE/UPLOAD_NEW_IMAGE';
export const UPDATE_NEW_IMAGE = 'BIRTH_CERTIFICATE/UPDATE_NEW_IMAGE';
export const SYNC_TO_ES = 'BIRTH_CERTIFICATE/SYNC_TO_ES';
export const GET_SINGLE_USER_MANAGEMENT =
  'BIRTH_CERTIFICATE/get_single_user_management';
export const UPDATE_USER_MANAGEMENT =
  'BIRTH_CERTIFICATE/update_user-_management';
export const CREATE_USER_MANAGEMENT = 'BIRTH_CERTIFICATE/create_brangay';
export const REMOVE_USER_MANAGEMENT =
  'BIRTH_CERTIFICATE/remove_user_management';
export const GET_BORONGAN_BARANGAY_LIST = 'BIRTH_CERTIFICATE/get_borongan_barangay_list'

export const GET_ROLE_LIST = 'ROLE/get_role_list';

export const FORM_DATA = {
  first_name: '',
  last_name: '',
  middle_name: '',
  birth_place: '',
  birth_date: '',
  mothers_last_name: '',
  mothers_first_name: '',
  mothers_middle_name: '',
  registry_number: '',
};

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const GET_REGION = 'OVRS/get_regions';
export const GET_PROVINCE = 'OVRS/get_provinces';
export const GET_MUNICIPALITIES = 'OVRS/get_municipalities';
export const GET_BARANGAYS = 'OVRS/get_barangays';

export const BIRTH_PLACE = [
  { label: 'Borongan Hospital', value: 'Borongan Hospital' },
  { label: 'OTHERS', value: 'OTHERS' },
]